import { primaryColor, hexToRgb, whiteColor, blackColors, dangerColor } from 'assets/jss/material-dashboard-pro-react';
import { darken } from '@material-ui/core/styles';
import Done from 'assets/img/done.svg';

const iconStyle = {
	height: '16px',
	width: 'auto',
	maxWidth: '16px',
	color: blackColors[3],
};

const customSearchStyle = (theme) => ({
	searchWrapper: {
		transition: 'all .1s ease-in-out',
		position: 'relative',
	},
	searchWrapperOpen: {
		zIndex: 1,
	},
	closeIcon: {
		...iconStyle,
		cursor: 'pointer',
		'&:hover': {
			color: blackColors[2],
		},
	},
	arrowIcon: {
		...iconStyle,
		transition: 'all .2s ease-in-out',
	},
	arrowRotated: {
		transform: 'rotate(180deg)',
	},
	dropdown: {
		height: 0,
		overflow: 'hidden',
		width: '100%',
		backgroundColor: whiteColor,
		position: 'absolute',
		zIndex: 10,
	},
	open: {
		height: 'auto',
		borderRadius: '4px',
		boxShadow: '0 8px 8px -6px rgba(0, 0, 0, 0.5)',
	},
	itemsWrapper: {
		overflowY: 'scroll',
		'& p': {
			lineHeight: theme.direction === 'rtl' ? 1.2 : 'normal',
		},
	},
	menuItem: {
		transition: 'all .1s ease-in-out',
		padding: '0 8px',
		paddingTop: '1px',
		height: '40px',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'flex-start',
		userSelect: 'none',
		'&:active': {
			backgroundColor: darken(primaryColor[0], 0.12),
			color: `${whiteColor}!important`,
			'& *': {
				color: `${whiteColor}!important`,
			},
		},
	},
	activeMenuItem: {
		backgroundColor: `rgba(${hexToRgb(primaryColor[0])}, 0.2)`,
	},
	selectedMenuItem: {
		backgroundColor: darken(primaryColor[0], 0.24),
		backgroundImage: `url(${Done})`,
		backgroundRepeat: 'no-repeat',
		backgroundSize: '14px',
		backgroundPosition: '90%',
		color: `${whiteColor}!important`,
		'&:active': {
			backgroundColor: darken(primaryColor[0], 0.24),
		},
		'& *': {
			color: `${whiteColor}!important`,
		},
	},
	selectedValueWrapper: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		borderBottom: `1px solid ${blackColors[4]}`,
		marginBottom: '8px',
		userSelect: 'none',
		paddingBottom: '3px',
		'& > p': {
			transition: 'all .1s ease-in-out',
			marginBottom: 0,
			lineHeight: theme.direction === 'rtl' ? 1.2 : 'normal',
		},
		'&:hover': {
			'& > p': {
				color: blackColors[1],
			},
		},
	},
	valueSelected: {
		borderBottom: `2px solid ${blackColors[2]}`,
		paddingBottom: '2px',
	},
	valueFocused: {
		borderBottom: `2px solid ${primaryColor[0]}`,
		paddingBottom: '2px',
	},
	valueError: {
		borderBottom: `2px solid ${dangerColor[0]}`,
	},
	searchInputWrapper: {
		position: 'relative',
		paddingLeft: '8px',
		paddingRight: '8px',
		'& .MuiFormControl-root': {
			marginTop: '-10px',
		},
		'& .MuiInputLabel-root': {
			paddingLeft: '20px',
		},
		'& .MuiInputLabel-shrink': {
			display: 'none',
		},
		'& .MuiInputBase-input': {
			paddingLeft: '20px',
		},
	},
	searchIcon: {
		...iconStyle,
		position: 'absolute',
		top: '25px',
		left: '8px',
	},
	noResults: {
		paddingLeft: '8px',
		height: '40px',
		display: 'flex',
		alignItems: 'center',
	},
});

export default customSearchStyle;
